import { PayloadAction, createSlice } from "@reduxjs/toolkit";
export interface MessagesState {
  loading: boolean;
  messagesLoader: boolean;
  buttonLoader: boolean;
  loadMoreLoader: boolean;
  showMore: boolean;

  usersList: any[];
  userDetails: any;

  chatMessages: any[];
  textValue: string;
}

const initialState: MessagesState = {
  loading: true,
  messagesLoader: true,
  buttonLoader: false,
  loadMoreLoader: false,
  showMore: false,

  usersList: [],
  userDetails: null,

  chatMessages: [],
  textValue: "",
};

export const messagesSlice = createSlice({
  name: "messages",
  initialState: initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setMessagesLoader: (state, action: PayloadAction<boolean>) => {
      state.messagesLoader = action.payload;
    },
    setUsersList: (state, action: PayloadAction<any[]>) => {
      state.usersList = action.payload;
    },
    setNewUser: (state, action: PayloadAction<any>) => {
      state.messagesLoader = true;
      state.loadMoreLoader = false;
      state.showMore = false;
      state.chatMessages = [];
      state.textValue = "";
      state.userDetails = action.payload;
    },
    setUserDetails: (state, action: PayloadAction<any>) => {
      state.userDetails = action.payload;
    },
    updateUserDetails: (
      state,
      action: PayloadAction<{
        key: string;
        value: any;
      }>
    ) => {
      state.userDetails[action.payload.key] = action.payload.value;
    },
    setChatMessages: (state, action: PayloadAction<any>) => {
      state.chatMessages = action.payload;
    },
    appendMessages: (state, action: PayloadAction<any>) => {
      state.chatMessages = [...state.chatMessages, ...action.payload];
    },
    prependMessages: (state, action: PayloadAction<any>) => {
      state.chatMessages = [...action.payload, ...state.chatMessages];
    },
    setTextValue: (state, action: PayloadAction<string>) => {
      state.textValue = action.payload;
    },
    setButtonLoader: (state, action: PayloadAction<boolean>) => {
      state.buttonLoader = action.payload;
    },
    setLoadMoreLoader: (state, action: PayloadAction<boolean>) => {
      state.loadMoreLoader = action.payload;
    },
    setShowMore: (state, action: PayloadAction<boolean>) => {
      state.showMore = action.payload;
    },
    reorderUsersList: (
      state,
      action: PayloadAction<{
        participantId: string;
      }>
    ) => {
      const { participantId } = action.payload;
      const index = state.usersList.findIndex(
        (user) => user.participantId === participantId
      );

      if (index > 0) {
        const [user] = state.usersList.splice(index, 1);
        state.usersList.unshift(user);
      }
    },
    updateUsersListUser: (
      state,
      action: PayloadAction<{
        participantId: string;
        key: string;
        value: any;
      }>
    ) => {
      const userIndex = state.usersList.findIndex(
        (user) => user.participantId === action.payload.participantId
      );

      if (userIndex > -1) {
        state.usersList[userIndex] = {
          ...state.usersList[userIndex],
          [action.payload.key]: action.payload.value,
        };
      }
    },
    reset: () => initialState,
  },
});

export const {
  setLoading,
  setMessagesLoader,
  setUsersList,
  setNewUser,
  setUserDetails,
  updateUserDetails,
  setChatMessages,
  appendMessages,
  prependMessages,
  setTextValue,
  setButtonLoader,
  setLoadMoreLoader,
  setShowMore,
  reorderUsersList,
  updateUsersListUser,
  reset,
} = messagesSlice.actions;

export default messagesSlice.reducer;
